import React from 'react';
import { motion } from 'framer-motion';
import { MiniDjayPrompt } from './MiniDjayPrompt';
import { SectionHeader } from '../ui/SectionHeader';
import { RADIUS } from '../../config/designTokens';
import type { DjayEmotion, DjayVariant } from '../../mascot';
interface WorldZoneProps {
  title: string;
  icon: React.ElementType;
  accentColor: string;
  children: React.ReactNode;
  djayMessage?: string;
  djayEmotion?: DjayEmotion;
  djayVariant?: DjayVariant;
  isLast?: boolean;
  className?: string;
}
export function WorldZone({
  title,
  icon: Icon,
  accentColor,
  children,
  djayMessage,
  djayEmotion = 'happy',
  djayVariant = 'default',
  isLast = false,
  className = ''
}: WorldZoneProps) {
  // Create a vibrant gradient background for the zone based on the accentColor
  const bgClass = accentColor.split(' ').find(c => c.startsWith('bg-')) || 'bg-indigo-100';
  const gradientFrom = bgClass.replace('-100', '-50');
  const gradientTo = bgClass.replace('-100', '-100/30');
  return <div className={`relative ${className}`} data-id="element-2795" data-mp="ukirb9hccx3j">
      <div className={`relative ${RADIUS.surface} p-6 sm:p-10 bg-gradient-to-b ${gradientFrom} ${gradientTo} border-2 border-white shadow-sm overflow-hidden`} data-id="element-2796" data-mp="uj7opczmtve0">
        
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-2797" data-mp="knmkr9b06l1m" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/30 rounded-full blur-2xl translate-y-1/4 -translate-x-1/4 pointer-events-none" data-id="element-2798" data-mp="bm6jbr261t9j" />

        {/* Header Area */}
        <div className="mb-10 relative z-10" data-id="element-2799" data-mp="1usdl1jmfx7y">
          <SectionHeader title={title} icon={Icon} accentColor={accentColor} size="lg" action={djayMessage ? <div className="hidden sm:block" data-id="element-2801" data-mp="3t365fjxlyv52">
                  <MiniDjayPrompt message={djayMessage} emotion={djayEmotion} data-id="element-2802" data-mp="3o31q3x8fs6gf" />
                </div> : undefined} data-id="element-2800" data-mp="1vtsjh3rd3uy" />
          
        </div>

        {/* Mobile Djay Prompt */}
        {djayMessage && <div className="mb-8 sm:hidden relative z-10" data-id="element-2803" data-mp="39ftckprnnp1a">
            <MiniDjayPrompt message={djayMessage} emotion={djayEmotion} data-id="element-2804" data-mp="39e9v4vu9j7xx" />
          </div>}

        {/* Content Area */}
        <div className="relative z-10" data-id="element-2805" data-mp="3ectgov4y2hpr">{children}</div>
      </div>

      {/* Visual Connector between zones */}
      {!isLast && <div className="relative h-16 w-full flex justify-center items-center" data-id="element-2806" data-mp="35dya3hxzn5lx">
          <div className="h-full w-2 border-l-4 border-dashed border-slate-200/80" data-id="element-2807" data-mp="35g2ncqhs1gyv" />
          <motion.div className="absolute w-4 h-4 rounded-full bg-slate-200" animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-2808" data-mp="3t4lsix5j5dmq" />
        
        </div>}
    </div>;
}